import React from "react"
import { IconButton, Tooltip } from "@mui/material"
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutlineOutlined"
import { DANGER } from "@/theme/tokens"

// Delete button of an editable waypoint, placed in the info card header.
export default function WaypointDeleteAction({
  onDelete,
  label = "Delete waypoint",
  disabled = false,
}) {
  return (
    <Tooltip title={label}>
      {/* span: a disabled button fires no events, the tooltip needs a live wrapper */}
      <span>
        <IconButton
          size="small"
          aria-label={label}
          onClick={onDelete}
          disabled={disabled}
          sx={{
            color: DANGER,
            pointerEvents: "auto",
            "&.Mui-disabled": { color: DANGER, opacity: 0.45 },
          }}
        >
          <DeleteOutlineIcon sx={{ fontSize: 18 }} />
        </IconButton>
      </span>
    </Tooltip>
  )
}
